import { Banner, BannerProps } from '@givebutter/primitives/banner';
import { useAppState } from 'customHooks/useAppState';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { SubscriptionStatus } from 'types/domain';

const BAD_STATUSES: SubscriptionStatus[] = ['incomplete', 'past_due', 'unpaid'];

const PaymentMethodIssueBanner = (props: BannerProps) => {
    const { apiUrl } = useAppState();
    const { accountId, validGivebutterPlusPlan } = useCurrentAccount();
    if (!validGivebutterPlusPlan || !BAD_STATUSES.includes(validGivebutterPlusPlan.status)) {
        return null;
    }

    const { statusMsg, actionMsg } = getPaymentIssueMessage(validGivebutterPlusPlan.status);

    return (
        <Banner type="warning" {...props}>
            <div className="w-full text-sm">
                <p className="font-medium">{statusMsg}</p>
                <p className="text-gray-600">{actionMsg}</p>
            </div>
            <a
                href={`${apiUrl}/dashboard/accounts/${accountId}/billing`}
                target="_blank"
                rel="noreferrer"
                className="text-nowrap"
            >
                Manage payment method
            </a>
        </Banner>
    );
};

const getPaymentIssueMessage = (status: SubscriptionStatus) => {
    if (status === 'incomplete') {
        return {
            statusMsg: "Your payment couldn't be processed.",
            actionMsg:
                'Please verify your payment details to activate your Givebutter Plus subscription.',
        };
    }
    return {
        statusMsg: "There's an issue with your payment method.",
        actionMsg: 'Please update to continue using Givebutter Plus.',
    };
};

export { PaymentMethodIssueBanner };
